var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.71329C15 10.8951 13.95 12.8252 12.2875 14L11.85 13.5804L10.0125 11.8182L11.2375 10.6434L12.2875 11.6503C12.725 11.0629 13.075 10.3077 13.1625 9.55245H11.5V7.87413H13.1625C12.9875 7.11888 12.725 6.44755 12.2875 5.77622L11.2375 6.78322L10.0125 5.60839L11.0625 4.6014C10.45 4.18182 9.6625 3.84615 8.875 3.76224V5.35664H7.125V3.76224C6.3375 3.93007 5.6375 4.18182 4.9375 4.6014L7.5625 7.11888C7.7375 7.11888 7.825 7.03497 8 7.03497C8.46413 7.03497 8.90925 7.21179 9.23744 7.52653C9.56563 7.84128 9.75 8.26817 9.75 8.71329C9.75 9.15841 9.56563 9.58529 9.23744 9.90004C8.90925 10.2148 8.46413 10.3916 8 10.3916C7.02875 10.3916 6.25 9.64476 6.25 8.71329C6.25 8.54545 6.25 8.46154 6.3375 8.29371L3.7125 5.77622C3.275 6.36364 2.925 7.11888 2.8375 7.87413H4.5V9.55245H2.8375C3.0125 10.3077 3.275 10.979 3.7125 11.6503L4.7625 10.6434L5.9875 11.8182L3.7125 14C2.05 12.8252 1 10.8951 1 8.71329C1 5.0042 4.1325 2 8 2C11.8675 2 15 5.0042 15 8.71329Z",
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimit);
export default __webpack_public_path__ + "static/media/limit.0662d10a4d1f7b206c6cc2415974e781.svg";
export { ForwardRef as ReactComponent };